module.exports = __webpack_public_path__ + "static/media/tick.d38f798d.svg";